import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { BancoService } from 'src/app/services/banco.service';
import { DepositoDocumentoService } from 'src/app/services/deposito-documento.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { TipoChequeService } from 'src/app/services/tipo-cheque.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { FileDownloadService } from "src/app/shared/services/file-download.service";
import * as _ from "lodash";

@Component({
  selector: 'app-cheques-consultar',
  templateUrl: './cheques-consultar.component.html',
  styleUrls: ['./cheques-consultar.component.scss'],
  providers: [SecurityService],
})
export class ChequesConsultarComponent implements OnInit {

  // Form
  formHeader: FormGroup

  // data & tmp
  private rutEmpresa: number
  private sucursalEmpresa: number
  optionsTipoCheque: Array<any> = [];
  optionsBancoOri: Array<any> = [];
  optionsBancoDes: Array<any> = [];
  paginationContext: PaginationContext = new PaginationContext()
  listaChequesAll: Array<any> = null
  listaCheques: Array<any> = null
  loading: boolean = false

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private fb: FormBuilder,
    private toastrService: ToastService,
    private formValidatorsService: FormValidatorsService,
    private messageRendererService: MessageRendererService,
    private tipoChequeService: TipoChequeService,
    private bancoService: BancoService,
    private depositoDocumentoService: DepositoDocumentoService,
    private rutService: RutService,
    private datesService: DatesService,
    private fileDownloadService: FileDownloadService,
  ) {
    this.log = this.clog.log('CHEQUES-CONSULTAR')
  }

  ngOnInit() {

    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())

    this.paginationContext.RecordsByPage = 10

    this.tiposCheques()
    this.getBancos()
    this.createForm()
  }

  private tiposCheques() {
    this.tipoChequeService.GetTiposCheques(({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsTipoCheque = registros.map(tipo => ({ value: tipo.codigo, label: tipo.nombre, ...tipo }))
    })
  }

  private getBancos() {
    this.bancoService.obtenerSegunFiltro(
      '',
      true,
      ({ mensajes, respuesta }) => {
        const { registros } = respuesta
        this.optionsBancoOri = registros.map(banco => ({ value: banco.codigo, label: banco.nombre, ...banco }))
        this.optionsBancoDes = registros.map(banco => ({ value: banco.codigo, label: banco.nombre, ...banco }))
      }
    )
  }

  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formHeader = this.fb.group({
      tiposCheque: [[]],
      fechaDesde: [currentDate],
      fechaHasta: [currentDate],
      bancosOrigen: [[]],
      bancosDestino: [[]],
      nroDoc: [null],
    });
  }

  buscar(pageNumber) {
    this.paginationContext.CurrentPage = pageNumber

    this.listaCheques = null
    //this.listaChequesAll = null

    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid)
      return

    const inputParams = this.createInputParams()
    this.log('buscar', JSON.stringify(inputParams))
    this.loading = true

    this.depositoDocumentoService.obtenerTodosChequesSegunFiltros(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        this.loading = false

        return
      }
      const { registros } = respuesta

      this.listaChequesAll = registros
      this.paginationContext.RecordsCount = this.listaChequesAll.length //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage) //totalPaginas
      this.paginationContext.CurrentPage = 1
      this.loading = false

      this.showPage(this.paginationContext.CurrentPage)
      this.listaCheques.map(pago => {
        pago.cliente_proveedor_rutFormato = this.rutService.AgregarDV(pago.cliente_proveedor_rut)
        pago.glosa_estado = this.tipoChequeService.GetLabelByValue(pago.estado)
        pago.n_deposito = pago.numero_deposito === 0 ? '' : pago.numero_deposito
      })
    })
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage
    this.listaCheques = _.slice(this.listaChequesAll, start, start + this.paginationContext.RecordsByPage)
  }


  createInputParams() {
    return {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        tipo_cheque: this.formHeader.get('tiposCheque').value,
        fecha_desde: this.formHeader.get('fechaDesde').value,
        fecha_hasta: this.formHeader.get('fechaHasta').value,
        bancos_origen: this.formHeader.get('bancosOrigen').value,
        bancos_destino: this.formHeader.get('bancosDestino').value,
        numero_doc: this.formHeader.get('nroDoc').value || 0,
        retornaExcel: false,
        retornaPDF: false
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1 //this.paginationContext.RecordsByPage
    }
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage)
  }

  limpiarfiltros() {
    this.formValidatorsService.reset(this.formHeader)
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formHeader.get('tiposCheque').setValue([])
    this.formHeader.get('fechaDesde').setValue(initDate)
    this.formHeader.get('fechaHasta').setValue(currentDate)
    this.formHeader.get('bancosOrigen').setValue([])
    this.formHeader.get('bancosDestino').setValue([])
    this.formHeader.get('nroDoc').setValue(null)

    this.listaCheques = null
  }

  downloadExcel(type: 'XLS' | 'PDF' = 'XLS') {
    const inputParams = _.cloneDeep(this.createInputParams())
    inputParams.paginaActual = 1
    inputParams.cantidadRegistrosPorPagina = -1
    inputParams.entidad.retornaExcel = type === 'XLS'

    this.log('inputParams', JSON.stringify(inputParams))

    this.depositoDocumentoService.obtenerExcelTodosChequesSegunFiltros(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }

  downloadPdf(type: 'XLS' | 'PDF' = 'PDF') {
    const inputParams = _.cloneDeep(this.createInputParams())
    inputParams.entidad.retornaPDF = type === 'PDF'
    inputParams.paginaActual = 1
    inputParams.cantidadRegistrosPorPagina = -1

    this.log('inputParams', JSON.stringify(this.createInputParams()))

    this.depositoDocumentoService.obtenerPDFTodosChequesSegunFiltros(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }
}
